package com.eladfinish.bible.contest.di.config

import com.eladfinish.bible.contest.di.apiModule
import com.eladfinish.bible.contest.di.sharedModule
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.core.module.Module

fun initKoin(
    koinConfig: KoinConfiguration,
    additionalModules: List<Module> = emptyList(),
    beforeModulesLoading: KoinApplication.() -> Unit = {},
    afterModulesLoading: KoinApplication.() -> Unit = {},
): KoinApplication {
    return startKoin {
        beforeModulesLoading()
        modules(
            sharedModule,
            koinConfig.module,
            apiModule(),
            *additionalModules.toTypedArray()
        )
        afterModulesLoading()
    }
}
